module.exports = __webpack_public_path__ + "img/chrom.8d91852f.png";